import { customAxios, customPatchAxios } from "./customAxios";

/**
 * 스펙 페이지 목록
 * @param {*} query 
 * @returns 
 */
export const getSpecKeysByQuery = async(query)=>{
  const res = await customAxios.get('/api/specKeys', {params : query});
  //console.log(res);
  if (res.data) {
     return res.data;
  }
  return null;
}

/**
 * 스펙 정보
 * @param {*} id 
 * @returns 
 */
export const getSpecKeysById = async(id)=>{
  const res = await customAxios.get('/api/specKeys/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 스펙 등록
 * @param {*} body 
 */ 
export const addSpecKeys = async(body)=>{
  //console.log(body);
  await customPatchAxios.post('/api/specKeys', body);
}

/**
 * 스펙 일괄 등록
 * @param {*} body 
 */ 
export const addAllSpecKeys = async(body)=>{
  //console.log(body);
  const res =  await customPatchAxios.patch('/api/specKeys', body);
//   console.log(res);
}

/**
 * 스펙 수정
 * @param {*} body 
 */ 
export const updateSpecKeys = async(body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/specKeys/'+body.id, body);
}

/**
 * 스펙 삭제
 * @param {*} body 
 */ 
export const deleteSpecKeys = async(id)=>{
  //console.log(body);
  await customPatchAxios.delete('/api/specKeys/'+id);
}

/******************************************************************************/


/**
 * 코드 페이지 목록
 * @param {*} query 
 * @returns 
 */
export const getMeasurementCodesByQuery = async(query)=>{
  const res = await customAxios.get('/api/measurementCodes', {params : query});
  //console.log(res);
  if (res.data) {
     return res.data;
  }
  return null;
}

/**
 * 코드 정보
 * @param {*} id 
 * @returns 
 */
export const getMeasurementCodesById = async(id)=>{
  const res = await customAxios.get('/api/measurementCodes/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 코드 등록
 * @param {*} body 
 */ 
export const addMeasurementCodes = async(body)=>{
  //console.log(body);
  await customPatchAxios.post('/api/measurementCodes', body);
}

/**
 * 코드 일괄 등록
 * @param {*} body 
 */ 
export const addAllMeasurementCodes = async(body)=>{
  //console.log(body);
  const res =  await customPatchAxios.patch('/api/measurementCodes', body);
//   console.log(res);
}

/**
 * 코드 수정
 * @param {*} body 
 */ 
export const updateMeasurementCodes = async(body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/measurementCodes/'+body.id, body);
}

/**
 * 코드 삭제
 * @param {*} body 
 */ 
export const deleteMeasurementCodes = async(id)=>{
  //console.log(body);
  await customPatchAxios.delete('/api/measurementCodes/'+id);
}
